<template>
  <v-app>
    <router-view></router-view>
    <confirm ref="confirm"></confirm>
  </v-app>
</template>

<script>
import Confirm from "@/components/Confirm.vue";
export default {
  name: "App",
  components: {
    Confirm
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
  },
  data: () => ({
    intervalId: undefined
  }),
  created() {
    try {
      // NOTE: 45min refresh policy is what google recommends: Google APIs
      this.intervalId = window.setInterval(this.$refreshToken(), 2.7e6);
    } catch (e) {
      console.error(e);
    }
  },
  destroyed() {
    if (typeof this.intervalId !== "undefined") {
      window.clearInterval(this.intervalId);
    }
  }
};
</script>
